import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { Input } from "@/components/ui/input"
import { TreatmentForm } from "@/modules/admin/treatment/schema/treatment-form-schema"
import { Language, LanguageValues } from "@/types/__generated__/union-types"

type TitleFieldName = "germanTitle" | "frenchTitle" | "italianTitle" | "englishTitle"

const TITLE_FIELD_BY_LANGUAGE: Record<Language, TitleFieldName> = {
  GERMAN: "germanTitle",
  FRENCH: "frenchTitle",
  ITALIAN: "italianTitle",
  ENGLISH: "englishTitle",
}

const titleFields = LanguageValues.map((language) => ({ language, fieldName: TITLE_FIELD_BY_LANGUAGE[language] }))

const TreatmentPlanTemplatesSectionTitleForm = () => {
  const { t } = useTranslation()

  const form = useFormContext<TreatmentForm>()

  const {
    register,
    formState: { errors: formErrors },
  } = form

  return (
    <>
      <div className="text-on-surface-subdued col-span-4 text-sm font-medium">
        <label>{t("admin.treatment.form.title")}</label>
      </div>
      {titleFields.map(({ language, fieldName }) => (
        <Input
          key={language}
          {...register(fieldName)}
          testId={`${language.toLowerCase()}-title`}
          label={t(`admin.treatment.form.${language.toLowerCase()}`)}
          required
          error={t(formErrors[fieldName]?.message ?? "", { max: 50 })}
          errorClasses="truncate"
        />
      ))}
    </>
  )
}

export { TreatmentPlanTemplatesSectionTitleForm }
